import { useMediaQuery } from 'react-responsive';

const TwoColumnsView = ({ children }) => {
    const isTwoColumnsView = useMediaQuery({ minWidth: 1162 });
    return <>{isTwoColumnsView && children}</>;
};

export default TwoColumnsView;
